import { useEntityUrl } from 'framework/routing';

export const ARTIFACT_STORAGE_PATH = '/artifact-storage';

export const useArtifactStorageUrl = () => {
  const entityUrl = useEntityUrl({
    baseLink: ARTIFACT_STORAGE_PATH,
  });
  const getSingleEntityUrl = (id?: any): string => `${ARTIFACT_STORAGE_PATH}/file/${id}`;

  return {
    ...entityUrl,
    getSingleEntityUrl,
  };
};
